// Форматирование значений для таблиц.

const BYTE_UNITS = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];

// 1536 → «1.5 КБ». null/undefined — прочерк: трафик неизвестен, а не ноль
export const formatBytes = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  let n = Number(value);
  if (!Number.isFinite(n) || n < 0) return '—';
  let unit = 0;
  while (n >= 1024 && unit < BYTE_UNITS.length - 1) {
    n /= 1024;
    unit += 1;
  }
  const digits = unit === 0 || n >= 100 ? 0 : 1;
  return `${n.toFixed(digits)} ${BYTE_UNITS[unit]}`;
};

// Секунды → «2 д 3 ч», «1 ч 05 мин», «4 мин 10 с». Две старшие единицы
// достаточно: точность до секунды на многодневной сессии никому не нужна
export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined) return '—';
  let s = Math.max(0, Math.round(Number(seconds)));
  if (!Number.isFinite(s)) return '—';
  const d = Math.floor(s / 86400); s -= d * 86400;
  const h = Math.floor(s / 3600);  s -= h * 3600;
  const m = Math.floor(s / 60);    s -= m * 60;
  const pad = (v) => String(v).padStart(2, '0');
  if (d) return `${d} д ${h} ч`;
  if (h) return `${h} ч ${pad(m)} мин`;
  if (m) return `${m} мин ${pad(s)} с`;
  return `${s} с`;
};

// ISO-строка → локальные дата и время
export const formatDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
};

// Сумма → «1 520,75». null и не число — прочерк: сумма неизвестна, а не ноль
export const formatMoney = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
